/*
 * Copyright (c) Nexign, JSC, 2020-2024.
 */
/**
 * Constants for logging
 *
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @author Alexander Golshtein
 * @author Ilya Baranchikov
 * @version 1.28.0
 * @since 1.1.1
 */

export const LOG_BUSINESS_EVENT = '@@b2b_portal_ui/logging/LOG_BUSINESS_EVENT';
export const LOG_BUSINESS_EVENT_SUCCESS = '@@b2b_portal_ui/logging/LOG_BUSINESS_EVENT_SUCCESS';
export const LOG_BUSINESS_EVENT_FAILED = '@@b2b_portal_ui/logging/LOG_BUSINESS_EVENT_FAILED';

export enum ELogBusinessEventType {
    common = 'common',
    login = 'login',
    wizard = 'master',
}

export enum ELogBusinessEventName {
    B2B_EVENT_ERROR = 'error',
    USER_AUTH = 'user_auth',

    USER_SHOW_PAYMENTS = 'user_show_payments',
    B2B_SHOW_PAYMENTS = 'b2b_show_payments',

    USER_SHOW_EXPENSES = 'user_show_expenses',
    B2B_SHOW_EXPENSES = 'b2b_show_expenses',

    USER_SHOW_BILLS = 'user_show_bills',
    B2B_SHOW_BILLS = 'b2b_show_bills',

    USER_TO_SOHO_VERSION = 'user_sohoVersion',

    //historyInquiry creation
    USER_SHOW_INQUIRY_MASTER = 'user_inquiry_master',
    B2B_SHOW_INQUIRY_MASTER = 'b2b_inquiry_master',
    /* @deprecated TODO: CreateInquiry v3 BBPORTAL-12551  */
    USER_CHOOSE_INQUIRY_TOPIC = 'user_inquiry_theme',
    /* @deprecated TODO: CreateInquiry v3 BBPORTAL-12551  */
    B2B_SHOW_INQUIRY_PARAMETERS = 'b2b_inquiry_parameters',
    USER_CREATE_INQUIRY = 'user_inquiry_create',
    B2B_CREATE_INQUIRY = 'b2b_inquiry_create',

    //forwarding
    USER_SHOW_REDIRECT_POPUP = 'user_redirect_browse',
    B2B_SHOW_REDIRECT_POPUP = 'b2b_redirect_form',
    USER_REDIRECT_CREATE_ORDER = 'user_redirect_rdy',
    B2B_REDIRECT_CREATE_ORDER = 'b2b_redirect_rdy',

    //change SIM card
    USER_CHANGE_SIM_MASTER = 'user_changeSIM_master',
    B2B_CHANGE_SIM_MASTER = 'b2b_changeSIM_master',
    USER_CHANGE_SIM_CREATE_ORDER = 'user_changeSIM_rdy',
    B2B_CHANGE_SIM_CREATE_ORDER = 'b2b_changeSIM_rdy',

    //change lock
    USER_BLOCK_MASTER_TO_STEP_1 = 'user_block_master_to_step1',
    B2B_BLOCK_MASTER_ON_STEP_1 = 'b2b_block_master_on_step1',
    USER_BLOCK_MASTER_TO_STEP_2 = 'user_block_master_to_step2',
    B2B_BLOCK_MASTER_ON_STEP_2 = 'b2b_block_master_on_step2',
    USER_BLOCK_MASTER_TO_STEP_3 = 'user_block_master_to_step3',
    B2B_BLOCK_MASTER_ON_STEP_3 = 'b2b_block_master_on_step3',
    USER_BLOCK_MASTER_CREATE_ORDER = 'user_block_master_create_order',
    B2B_BLOCK_MASTER_CREATE_ORDER = 'b2b_block_master_create_order',

    //change access level
    USER_ACCESS_LEVEL_MASTER_TO_STEP_1 = 'user_accessLevel_master_to_step1',
    B2B_ACCESS_LEVEL_MASTER_ON_STEP_1 = 'b2b_accessLevel_master_on_step1',
    USER_ACCESS_LEVEL_MASTER_TO_STEP_2 = 'user_accessLevel_master_to_step2',
    B2B_ACCESS_LEVEL_MASTER_ON_STEP_2 = 'b2b_accessLevel_master_on_step2',
    USER_ACCESS_LEVEL_MASTER_CREATE_ORDER = 'user_accessLevel_master_create_order',
    B2B_ACCESS_LEVEL_MASTER_CREATE_ORDER = 'b2b_accessLevel_master_create_order',

    //billsDocs master
    USER_BILLS_REPORTS_MASTER_TO_STEP_1 = 'user_bills_reports_master_to_step1',
    B2B_BILLS_REPORTS_MASTER_ON_STEP_1 = 'b2b_bills_reports_master_on_step1',
    USER_BILLS_REPORTS_MASTER_TO_STEP_2 = 'user_bills_reports_master_to_step2',
    B2B_BILLS_REPORTS_MASTER_ON_STEP_2 = 'b2b_bills_reports_master_on_step2',
    USER_BILLS_REPORTS_MASTER_CONFIRM = 'user_bills_reports_master_confirm',
    USER_FUCTURE_REPORTS_MASTER_CONFIRM = 'user_fucture_reports_master_rdy',
    USER_INVOICE_REPORTS_MASTER_CONFIRM = 'user_invOpl_reports_master_rdy',
    USER_FUCT_ACT_REPORTS_MASTER_CONFIRM = 'user_fuctAct_reports_master_rdy',
    B2B_BILLS_REPORTS_MASTER_CONFIRM = 'b2b_bills_reports_master_confirm',
    B2B_FUCTURE_REPORTS_MASTER_CONFIRM = 'b2b_fucture_reports_master_rdy',
    B2B_INVOICE_REPORTS_MASTER_CONFIRM = 'b2b_invOpl_reports_master_rdy',
    B2B_FUCT_ACT_REPORTS_MASTER_CONFIRM = 'b2b_fuctAct_reports_master_rdy',

    //Collation report master
    USER_R_COLLATION_MASTER_TO_STEP_1 = 'user_r_collation_master_to_step1',
    B2B_R_COLLATION_MASTER_ON_STEP_1 = 'b2b_r_collation_master_on_step1',
    USER_R_COLLATION_MASTER_TO_STEP_2 = 'user_r_collation_master_to_step2',
    B2B_R_COLLATION_MASTER_ON_STEP_2 = 'b2b_r_collation_master_on_step2',
    USER_R_COLLATION_MASTER_CONFIRM = 'user_r_collation_master_confirm',
    B2B_R_COLLATION_MASTER_CONFIRM = 'b2b_r_collation_master_confirm',

    // call details
    USER_CALL_DETAILS_MASTER_TO_STEP_1 = 'user_rCliCalls_master_to_step1',
    B2B_CALL_DETAILS_MASTER_ON_STEP_1 = 'b2b_rCliCalls_master_on_step1',
    USER_CALL_DETAILS_MASTER_TO_STEP_2 = 'user_rCliCalls_master_to_step2',
    B2B_CALL_DETAILS_MASTER_ON_STEP_2 = 'b2b_rCliCalls_master_on_step2',
    USER_CALL_DETAILS_MASTER_CREATE_ORDER = 'user_rCliCalls_master_create_order',
    B2B_CALL_DETAILS_MASTER_CREATE_ORDER = 'b2b_rCliCalls_master_create_order',

    //Change packaged rate plan master
    USER_RATE_PLAN_MASTER_TO_STEP_1 = 'user_ratePlan_master_browse',
    B2B_RATE_PLAN_MASTER_ON_STEP_1 = 'b2b_ratePlan_master_step1',
    USER_RATE_PLAN_MASTER_TO_STEP_2 = 'user_ratePlan_master_goToStep2',
    B2B_RATE_PLAN_MASTER_ON_STEP_2 = 'b2b_ratePlan_master_step2',
    USER_RATE_PLAN_MASTER_TO_STEP_3 = 'user_ratePlan_master_goToStep3',
    B2B_RATE_PLAN_MASTER_ON_STEP_3 = 'b2b_ratePlan_master_step3',
    USER_RATE_PLAN_MASTER_CREATE_ORDER = 'user_ratePlan_master_rdy',
    B2B_RATE_PLAN_MASTER_CREATE_ORDER = 'b2b_ratePlan_master_rdy',

    //additional reports (Абоненты, подошедшие к порогу отключения)
    USER_ADD_REPORTS_CONSTRUCTOR = 'user_addRep_constructor_browse',
    USER_ADD_REPORTS_MASTER_TO_STEP_1 = 'user_addRep_master_browse',
    B2B_ADD_REPORTS_MASTER_ON_STEP_1 = 'b2b_addRep_master_step1',
    USER_ADD_REPORTS_MASTER_TO_STEP_2 = 'user_addRep_master_goToStep2',
    B2B_ADD_REPORTS_MASTER_ON_STEP_2 = 'b2b_addRep_master_step2',
    USER_ADD_REPORTS_MASTER_TO_STEP_3 = 'user_addRep_master_goToStep3',
    B2B_ADD_REPORTS_MASTER_ON_STEP_3 = 'b2b_addRep_master_step3',
    USER_ADD_REPORTS_MASTER_CREATE_REPORT = 'user_addRep_master_rdy',
    B2B_ADD_REPORTS_MASTER_CREATE_REPORT = 'b2b_addRep_master_rdy',

    //Change rate services master
    USER_SERVICES_MASTER_TO_STEP_1 = 'user_services_master_browse',
    B2B_SERVICES_MASTER_ON_STEP_1 = 'b2b_services_master_step1',
    USER_SERVICES_MASTER_TO_STEP_2 = 'user_services_master_goToStep2',
    B2B_SERVICES_MASTER_ON_STEP_2 = 'b2b_services_master_step2',
    USER_SERVICES_MASTER_TO_STEP_3 = 'user_services_master_goToStep3',
    B2B_SERVICES_MASTER_ON_STEP_3 = 'b2b_services_master_step3',
    USER_SERVICES_MASTER_TO_STEP_4 = 'user_services_master_goToStep4',
    B2B_SERVICES_MASTER_ON_STEP_4 = 'b2b_services_master_step4',
    USER_SERVICES_MASTER_CREATE_ORDER = 'user_services_master_rdy',
    B2B_SERVICES_MASTER_CREATE_ORDER = 'b2b_services_master_rdy',

    //Accounts page
    USER_ACCOUNTS = 'user_accountList',
    B2B_ACCOUNTS = 'b2b_accountList',

    //mobile subscribers page
    USER_MOBILE_SUBSCRIBERS = 'user_subscriberList',
    B2B_MOBILE_SUBSCRIBERS = 'b2b_subscriberList',

    // inquiries page
    USER_INQUIRIES = 'user_inquiry_history',
    B2B_INQUIRIES = 'b2b_inquiry_history',

    USER_SHOW_OTHER_INQUIRIES = 'user_show_other_inquiries',
    B2B_SHOW_OTHER_INQUIRIES = 'b2b_show_other_inquiries',

    //Orders history
    USER_ORDER_HISTORY = 'user_order_history',
    B2B_ORDER_HISTORY = 'b2b_order_history',

    // Account page
    USER_ACCOUNT = 'user_account',
    B2B_ACCOUNT = 'b2b_account',
    // Subscriber page
    USER_SUBSCRIBER_CARD = 'user_subscriberCard',
    B2B_SUBSCRIBER_CARD = 'b2b_subscriberCard',
    //historyInquiry page
    USER_SHOW_INQUIRY_INFO = 'user_inquiry_info',
    B2B_SHOW_INQUIRY_INFO = 'b2b_inquiry_info',

    //Order page
    USER_REPORT_ORDER_INFO = 'user_report_order_info',
    B2B_REPORT_ORDER_INFO = 'b2b_report_order_info',
    USER_REPORT_DOWNLOAD = 'user_report_download',
    USER_BLOCK_ORDER_INFO = 'user_block_order_info',
    B2B_BLOCK_ORDER_INFO = 'b2b_block_order_info',
    USER_ACCESS_LEVEL_ORDER_INFO = 'user_accessLevel_order_info',
    B2B_ACCESS_LEVEL_ORDER_INFO = 'b2b_accessLevel_order_info',
    USER_RATE_PLAN_ORDER_INFO = 'user_ratePlan_order_info',
    B2B_RATE_PLAN_ORDER_INFO = 'b2b_ratePlan_order_history',
    USER_SERVICES_ORDER_INFO = 'user_services_order_info',
    B2B_SERVICES_ORDER_INFO = 'b2b_services_order_history',

    // Wizard product offering
    USER_PAGE_PRODUCT_BROWSE = 'user_pageProduct_browse',
    USER_PAGE_PRODUCT = 'user_pageProduct',
    USER_PAGE_PRODUCT_MASTER_CREATE_ORDER = 'user_pageProduct_master_create_order',
    USER_MEGA_POWERS = 'user_megaPowers',

    // Wizard Subscribers Limits
    USER_IMPORT_LIMIT_MASTER_STEP_1 = 'user_importLimit_master_step1',
    B2B_IMPORT_LIMIT_MASTER_STEP_1 = 'b2b_importLimit_master_step1',
    USER_IMPORT_LIMIT_MASTER_STEP_2 = 'user_importLimit_master_step2',
    B2B_IMPORT_LIMIT_MASTER_STEP_2 = 'b2b_importLimit_master_step2',
    USER_IMPORT_LIMIT_MASTER_CREATE_ORDER = 'user_importLimit_master_create_order',

    // Dashboard
    B2B_DASHBOARD = 'b2b_dashboard',
    B2B_FULL_VERSION = 'b2b_fullVersion',

    // Email change via inquiry
    USER_DELIVERY_EMAIL_CHANGE = 'user_delivery_email_change',
}

export enum orderEventType {
    b2b = 'b2b',
    user = 'user',
}

export const orderEventMapping: { [key in orderEventType]: { [orderType: number]: ELogBusinessEventName } } = {
    [orderEventType.user]: {
        150190005: ELogBusinessEventName.USER_BLOCK_ORDER_INFO,
        150190041: ELogBusinessEventName.USER_BLOCK_ORDER_INFO,
        150190037: ELogBusinessEventName.USER_ACCESS_LEVEL_ORDER_INFO,
        150190043: ELogBusinessEventName.USER_ACCESS_LEVEL_ORDER_INFO,
        150190025: ELogBusinessEventName.USER_REPORT_ORDER_INFO, // Абоненты, подошедшие к лимиту
        150190064: ELogBusinessEventName.USER_REPORT_ORDER_INFO,
        150190019: ELogBusinessEventName.USER_REPORT_ORDER_INFO, // Детализация вызовов
        150190065: ELogBusinessEventName.USER_REPORT_ORDER_INFO,
        150190066: ELogBusinessEventName.USER_REPORT_ORDER_INFO,
        150190067: ELogBusinessEventName.USER_REPORT_ORDER_INFO,
        150190068: ELogBusinessEventName.USER_REPORT_ORDER_INFO,
        150190017: ELogBusinessEventName.USER_REPORT_ORDER_INFO, // Счет - фактура
        150190018: ELogBusinessEventName.USER_REPORT_ORDER_INFO, // Биллинговые счета
        150190053: ELogBusinessEventName.USER_REPORT_ORDER_INFO, // Акт оказанных услуг
        150190038: ELogBusinessEventName.USER_REPORT_ORDER_INFO, // Счет на оплату
        150190021: ELogBusinessEventName.USER_REPORT_ORDER_INFO,
        150190003: ELogBusinessEventName.USER_RATE_PLAN_ORDER_INFO,
        150190063: ELogBusinessEventName.USER_RATE_PLAN_ORDER_INFO,
        150190039: ELogBusinessEventName.USER_RATE_PLAN_ORDER_INFO,
        150190045: ELogBusinessEventName.USER_RATE_PLAN_ORDER_INFO,
        150190048: ELogBusinessEventName.USER_SERVICES_ORDER_INFO,
        150190062: ELogBusinessEventName.USER_SERVICES_ORDER_INFO,
        150190034: ELogBusinessEventName.USER_SERVICES_ORDER_INFO,
        150190047: ELogBusinessEventName.USER_SERVICES_ORDER_INFO,

        150190023: ELogBusinessEventName.USER_REPORT_ORDER_INFO, // Лимиты (абоненты с лимитами)
        150190026: ELogBusinessEventName.USER_REPORT_ORDER_INFO, // Параметры абонентов
        150190027: ELogBusinessEventName.USER_REPORT_ORDER_INFO, // Абоненты с блокировкой
        150190028: ELogBusinessEventName.USER_REPORT_ORDER_INFO, // Новые абоненты
        150190057: ELogBusinessEventName.USER_REPORT_ORDER_INFO, // Абоненты с блокировкой
        150190058: ELogBusinessEventName.USER_REPORT_ORDER_INFO, // Новые абоненты
        150190029: ELogBusinessEventName.USER_REPORT_ORDER_INFO, // Статические IP-адреса
    },

    [orderEventType.b2b]: {
        150190005: ELogBusinessEventName.B2B_BLOCK_ORDER_INFO,
        150190041: ELogBusinessEventName.B2B_BLOCK_ORDER_INFO,
        150190037: ELogBusinessEventName.B2B_ACCESS_LEVEL_ORDER_INFO,
        150190043: ELogBusinessEventName.B2B_ACCESS_LEVEL_ORDER_INFO,
        150190025: ELogBusinessEventName.B2B_REPORT_ORDER_INFO, // Абоненты, подошедшие к лимиту
        150190064: ELogBusinessEventName.B2B_REPORT_ORDER_INFO,
        150190019: ELogBusinessEventName.B2B_REPORT_ORDER_INFO, // Детализация вызовов
        150190065: ELogBusinessEventName.B2B_REPORT_ORDER_INFO,
        150190066: ELogBusinessEventName.B2B_REPORT_ORDER_INFO,
        150190067: ELogBusinessEventName.B2B_REPORT_ORDER_INFO,
        150190068: ELogBusinessEventName.B2B_REPORT_ORDER_INFO,
        150190017: ELogBusinessEventName.B2B_REPORT_ORDER_INFO, // Счет - фактура
        150190018: ELogBusinessEventName.B2B_REPORT_ORDER_INFO, // Биллинговые счета
        150190053: ELogBusinessEventName.B2B_REPORT_ORDER_INFO, // Акт оказанных услуг
        150190038: ELogBusinessEventName.B2B_REPORT_ORDER_INFO, // Счет на оплату
        150190021: ELogBusinessEventName.B2B_REPORT_ORDER_INFO,
        150190003: ELogBusinessEventName.B2B_RATE_PLAN_ORDER_INFO,
        150190063: ELogBusinessEventName.B2B_RATE_PLAN_ORDER_INFO,
        150190039: ELogBusinessEventName.B2B_RATE_PLAN_ORDER_INFO,
        150190045: ELogBusinessEventName.B2B_RATE_PLAN_ORDER_INFO,
        150190001: ELogBusinessEventName.B2B_SERVICES_ORDER_INFO,
        150190011: ELogBusinessEventName.B2B_SERVICES_ORDER_INFO,
        150190048: ELogBusinessEventName.B2B_SERVICES_ORDER_INFO,
        150190062: ELogBusinessEventName.B2B_SERVICES_ORDER_INFO,
        150190034: ELogBusinessEventName.B2B_SERVICES_ORDER_INFO,
        150190047: ELogBusinessEventName.B2B_SERVICES_ORDER_INFO,

        150190023: ELogBusinessEventName.B2B_REPORT_ORDER_INFO, // Лимиты (абоненты с лимитами)
        150190026: ELogBusinessEventName.B2B_REPORT_ORDER_INFO, // Параметры абонентов
        150190027: ELogBusinessEventName.B2B_REPORT_ORDER_INFO, // Абоненты с блокировкой
        150190028: ELogBusinessEventName.B2B_REPORT_ORDER_INFO, // Новые абоненты
        150190057: ELogBusinessEventName.B2B_REPORT_ORDER_INFO, // Абоненты с блокировкой
        150190058: ELogBusinessEventName.B2B_REPORT_ORDER_INFO, // Новые абоненты
        150190029: ELogBusinessEventName.B2B_REPORT_ORDER_INFO, // Статические IP-адреса
    },
};
